import { mapState } from 'vuex';
import f from "@/application/shared/functions.js";

export default {
    name: 'forminput',
    props: {
        placeholder : String,
        externalsend : Boolean
    },

    data : function(){

        return {
            textareavalue : '',
            recognition : null,
            nospeechrecognition : false,
            speech : false,
            loading : false,
        }

    },

    created() {
        this.initRecognition()
    },

    beforeDestroy(){
        this.abortRecognition()
    },

    watch: {
        textareavalue : function(){

            setTimeout(() => {
                this.textareasize()
            }, 50)
            

            this.$emit('input', this.textareavalue)
        },
        //$route: 'getdata'
    },
    computed: mapState({
        auth : state => state.auth,

        canMicrophoneInput : function(){
            return true
        },

        inputactive : function(){
            return this.textareavalue ? true : false
        },
    }),

    methods : {
        focus : function(){
            if (this.$refs['input'])
                this.$refs['input'].focus()
        },
        set : function(text){
            this.textareavalue = text
        },
        send : function(){
            this.$emit('send', this.textareavalue)

            this.textareavalue = ''
        },
        textareakeyup : function(event){
            this.textareavalue = event.target.value

            var text = f.trim(event.target.value).replace(/^\s+|\s+$/g, '')

            if(!text){

            }
            else{

                if ((event.keyCode == 10 || event.keyCode == 13)){

                    event.preventDefault()
                    event.stopPropagation()

                    if (event.ctrlKey){
                        this.textareavalue = text + '\n'
                    }
                    else{
                        if(!this.externalsend){
                            this.send(f.trim(text).trim())
                        }
                        else{
                            this.$emit('externalsend')
                        }
                        
                    }

                    return false
                }

                
            }
        },

        textareasize : function(){

            var input = this.$refs['input']

            if(this.textareavalue){
                input.style.height = 1 + "px";
                input.style.height = (input.scrollHeight || input.style.scrollHeight) + "px";
            }
            else{
                input.style.height = 52 + "px";
            }

            
        },
        
        initRecognition : function(){

            var constructor = window.SpeechRecognition || window.webkitSpeechRecognition

            if(!constructor || this.view == 'storyview'){

                this.nospeechrecognition = true

                return
            }

            var recognition = new (constructor)();

            var transcript = this.textareavalue
	        var intermresult = null

            var loc = this.$i18n.locale

            if (loc == 'ru') loc = 'ru-RU'
            if (loc == 'en') loc = 'en-US'

            recognition.lang = loc;
            recognition.interimResults = true;
            recognition.maxAlternatives = 1;

            recognition.onaudiostart = () => {
                this.speech = true
                transcript = this.textareavalue
            };


            recognition.onresult = (event) => {

                for (var i = event.resultIndex; i < event.results.length; i++) {
                    if(!i && event.results[i][0].confidence > 0){

                        if(!intermresult || ((intermresult.confidence < event.results[i][0].confidence) && !intermresult.isFinal)){

                            intermresult = {
                                value : event.results[i][0].transcript,
                                isFinal : event.results[i].isFinal,
                                confidence : event.results[i][0].confidence
                            }
                        }

                    }
                    
                }

                var r = [{
                    value : transcript
                }]

                if (intermresult){
                    r.push(intermresult)


                    if (intermresult.isFinal) {
                        intermresult = null
                    }

                }

                r = _.filter(r, (t) => {
                    return t.value
                })

                this.textareavalue = _.map(r, (v) => {
                    return v.value
                }).join(' ')

            };

            recognition.addEventListener('end', (event) => {
                transcript = this.textareavalue.replace(/\u200B/g,'')
                intermresult = null

                if (this.speech){
                    recognition.start()
                }
            });

            this.recognition = recognition
        },

        voiceInput : function(event){

            if(!this.recognition) return

            if (event){
                const speechRecognitionList = new SpeechGrammarList();
                this.recognition.grammars = speechRecognitionList;
            }

            this.recognition.start();
        
        },

        recognitionpermissions : function(){

            //if(!window.cordova) return Promise.reject('cordova')

            return new Promise((resolve, reject) => {

                function error(e) {

                    console.error(e)
    
                    reject('Permission to use the microphone has not been obtained.')
                }

                function success() {

                    resolve()
                    
                }

                try{
                    this.core.media.permissions({ audio: true }).then(success).catch(error)
                }
                catch(e){
                    console.error(e)
                }
    
            })

            
        },

        microphoneClick : function(){

            if (this.speech){

                this.abortRecognition()

               

            }
            else{

                if(this.loading) return

                this.recognitionpermissions().then(() => {
                    this.voiceInput()
                }).catch(e => {

                    console.error(e)

                    this.core.sitemessage(this.$t('errors.general'))

                   
                })
 
                
            }
                
        },

        abortRecognition : function(){
            if (this.speech){
                this.speech = false
                
                if (this.recognition)
                    this.recognition.abort()

            }
        }
    },
}